module.exports = __webpack_public_path__ + "clickup-4-757868b7a84120d3a61e65ecdf9beab2.webp";